const messagesKo = {
  about: '정보',
  acceptanceCriteria: '수락 기준',
  accomplishments: '성과',
  actions: '작업',
  activity: '활동',
  activatePod: 'POD 활성화',
  activePods: '활성 POD',
  add: '추가',
  addBlocker: '차단 정보 추가',
  addingCandidateWait: '후보자 추가 중, 잠시 기다려주세요...',
  addPortfolio: '포트폴리오 추가',
  addStakeholder: '이해관계자 추가',
  addVideoUpdate: '비디오 업데이트 추가',
  findAgents: '에이전트 찾기',
  all: '모두',
  allReporters: '모든 리포터',
  allRepoCheckins: '모든 저장소 체크인',
  approve: '승인',
  approved: '승인됨',
  approvalRequests: '승인 요청',
  approvedPRCount: '승인된 PR 수',
  assignedItems: '할당된 항목',
  availability: '가용성',
  availableDate: '이용 가능한 날짜',
  backToPods: '내 POD로 돌아가기',
  basicInformation: '기본 정보',
  blocker: '차단',
  blockerDetails: '차단 세부사항',
  blockers: '차단 요소',
  board: '보드',
  browseTalent: '인재 탐색',
  bugs: '버그',
  calendlyUrl: 'Calendly URL',
  cancel: '취소',
  candidates: '후보자',
  categories: '카테고리',
  certifications: '인증',
  certificationUrl: '인증 URL',
  checkBoxBlocker: '이것이 차단 요소인 경우 이 박스를 체크하세요',
  ciCdPipeline: 'CI/CD 파이프라인',
  clear: '지우기',
  client: '클라이언트',
  clickHereUploadVideoClip: '비디오 클립을 업로드하려면 여기를 클릭하세요!',
  cloudCost: '클라우드 비용',
  code: '코드 라인',
  codeSmells: '코드 스멜',
  commentHere: '여기에 댓글...',
  category: '카테고리',
  comments: '댓글',
  companyName: '회사명',
  copied: '복사됨!',
  copyright: '저작권 © 2025-현재 Brilli Global, Inc. 모든 권리 보유.',
  copyToClipboard: '클립보드에 복사',
  cost: '비용',
  costDetails: '비용 세부사항',
  country: '국가',
  create: '생성',
  createArt: 'ART 생성',
  createGig: '솔루션 생성',
  createPod: 'POD 생성',
  createProfile: '프로필 생성',
  createProfileOpportunity: '다양한 원격 근무 기회에 포함되도록 인재 데이터베이스에 프로필을 생성하세요.',
  createTask: '작업 생성',
  createYourOwnPod: '자신만의 POD를 생성하고 프로젝트를 탐색하세요',
  creatingProfile: '프로필 생성 중',
  currency: '통화',
  currentlyAvailable: '현재 이용 가능',
  currentWeek: '이번 주',
  dashboard: '대시보드',
  date: '날짜',
  dateRangeFilter: '날짜 범위 필터',
  deactivatePod: 'POD 비활성화',
  deactivateToUpdate: 'POD를 업데이트하려면 POD를 비활성화하세요!',
  defects: '결함',
  delete: '삭제',
  deletePod: 'POD 삭제',
  description: '설명',
  detailsForGitHubRepo: 'GitHub 저장소 세부사항',
  done: '닫기',
  Done: '완료',
  doraMetrics: 'Dora 메트릭',
  dueDate: '마감일',
  duplicatedLinesDensity: '중복 라인 밀도',
  edit: '편집',
  education: '교육',
  educationAndCertifications: '교육 및 인증',
  email: '이메일',
  podTime: 'POD 시간',
  createHub: '허브 생성',
  createSolution: '솔루션 생성',
  podVelocity: 'POD 속도',
  podBlockers: 'POD 차단 요소',
  podsync: 'POD 동기화',
  endDate: '종료 날짜',
  enterEmailToInvite: '초대할 이메일 입력',
  enterPodMission: 'POD 미션 입력',
  enterPodName: 'POD 이름 입력',
  enterStoryDescription: '스토리 설명 입력',
  executionDate: '실행 날짜',
  executionID: '실행 ID',
  externalPod: '외부 POD',
  fileNameNoSpaces: '파일 이름에는 모든 요소나 문자 사이에 공백이 포함되지 않아야 합니다',
  fileUpload: '파일 업로드',
  findBestFreelancers: '프로젝트를 더 빠른 속도로 완료할 수 있는 최고의 프리랜서나 인재 POD를 찾으세요!',
  findBestPod: '귀하의 경험/기술 세트와 일치하는 POD를 찾으세요',
  findPods: 'POD 찾기',
  findTalent: '인재 찾기',
  findYourBestTalentPod: '최고의 인재 POD를 찾으세요',
  firstName: '이름',
  focus: '집중',
  gitHubRepo: 'GitHub 저장소',
  gitHubUsername: 'GitHub 사용자명',
  github: 'Github',
  githubSummary: 'GitHub 요약',
  githubUrl: 'Github URL',
  githubUser: 'GitHub 사용자',
  giveRating: '평점 주기',
  globalWorkPlatform: '글로벌 작업 플랫폼',
  home: '홈',
  hoursPerWeek: '주당 시간',
  inactivePod: '비활성 POD',
  individual: '개인',
  industry: '산업',
  inProgress: '진행 중',
  institute: '기관',
  internalPod: '내부 POD',
  invite: '초대',
  invoices: '송장',
  issueKey: '이슈 키',
  issueStatus: '이슈 상태',
  issueSummary: '이슈 요약',
  jiraIssue: 'Jira 이슈',
  jiraIssues: 'Jira 이슈',
  jiraItem: 'Jira 항목',
  jiraTimeDetails: '시간 로그',
  jiraUsername: 'Jira 사용자명',
  keepDoing: '계속하기',
  keyword: '키워드',
  languageSpoken: '사용 언어',
  lastName: '성',
  latestSprintVelocity: '최신 스프린트 속도',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'LinkedIn URL',
  linesOfCodeByDay: '일별 코드 라인',
  listOfTalents: '인재 목록',
  loading: '로딩 중',
  loadingAcceptanceCriteria: '수락 기준 로딩 중',
  loadingStoryDescription: '스토리 설명 로딩 중',
  loadingTestCases: '테스트 케이스 로딩 중',
  logOut: '로그아웃',
  login: '로그인',
  manage: '관리',
  manageActivities: '일일 POD 활동 및 업데이트 관리',
  manageProfile: '프로필 관리',
  manageProfileHere: '여기서 프로필을 관리하세요',
  managePod: 'POD 관리',
  managePods: '모든 POD 및 활동 관리',
  markComplete: '완료 표시',
  middleName: '가운데 이름',
  myPods: '내 POD',
  myTasks: '내 작업',
  name: '이름',
  ncloc: 'Ncloc',
  newActivityUpdate: '새 활동 업데이트',
  next: '다음',
  noArtOptionsAvailable: '사용 가능한 ART 옵션 없음',
  noBlockers: '차단 요소 없음',
  noCandidates: '추가된 후보자 없음',
  noCandidatesAddedToPod: 'POD에 추가된 후보자 없음!',
  noCandidateReviews: '후보자 리뷰가 없습니다.',
  noData: '데이터 없음',
  noDataAvailable: '사용 가능한 데이터 없음',
  noExperience: '경험 없음',
  noMatchingPods: '일치하는 POD가 없습니다',
  noNotifications: '알림이 없습니다',
  noPodActivity: 'POD 활동이 없습니다',
  noPods: 'POD가 없습니다',
  noPodTasks: 'POD 작업이 없습니다',
  noReviews: '리뷰가 없습니다.',
  noStakeholders: '이 POD에 대한 이해관계자가 없습니다',
  noSubscription: '구독 계획이 없습니다',
  noVideoAvailable: '사용 가능한 비디오 없음',
  notifications: '알림 수신자',
  otherInformation: '기타 정보',
  pending: '대기 중',
  pendingPods: '대기 중인 POD',
  phoneNumber: '전화번호',
  pipelineExecutionDetails: '파이프라인 실행 세부사항',
  pipelineName: '파이프라인 이름',
  pipelineVersion: '파이프라인 버전',
  pleaseEnterStoryDescription: '스토리 설명을 입력하고 제출을 클릭하세요',
  POD: 'POD',
  podActivities: 'POD 활동',
  podActivity: 'POD 활동',
  podAnalytics: 'POD 분석',
  podAssist: 'POD 어시스턴트',
  podAutomation: 'POD 자동화',
  podBoard: 'POD 보드',
  podCategories: 'POD 카테고리',
  podDescription: 'POD 설명',
  podExperience: 'POD 경험',
  podFeedback: 'POD 피드백',
  podMetrics: 'POD 메트릭',
  podName: 'POD 이름',
  podQuery: 'POD 쿼리',
  podRequests: 'POD 요청',
  podRetro: 'POD 회고',
  podSize: 'POD 크기',
  podTasks: 'POD 작업',
  podTaskDescription: 'POD 작업 설명',
  podTaskDueDate: 'POD 작업 마감일',
  podTaskName: 'POD 작업 이름',
  podTaskOwner: 'POD 작업 소유자',
  podTaskStatus: 'POD 작업 상태',
  podTechStack: 'POD 기술 스택',
  podTeamMember: 'POD 팀 멤버',
  podType: 'POD 유형',
  portfolio: '포트폴리오',
  portfolioUrl: '포트폴리오 URL',
  post: '게시',
  postActivity: '활동 게시',
  postPodActivity: 'POD 활동 게시',
  postRequirement: '요구사항 게시',
  posting: '게시 중...',
  postedDate: '게시 날짜',
  postedRequirements: '게시된 POD 요구사항',
  positionName: '직책명',
  prCount: 'PR 수',
  preferredWorkHours: '선호 근무 시간',
  prev: '이전',
  previousPods: '이전 POD',
  previousWeek: '지난 주',
  primarySkill: '주요 기술',
  privacyPolicy: '개인정보 보호정책',
  privatePods: '비공개 POD',
  prSummary: 'PR 요약',
  projectKey: '프로젝트 키',
  profileLink: '프로필 링크',
  profileVisibility: '프로필 가시성',
  public: '공개',
  qualification: '자격',
  ratePerHour: '시간당 요금',
  ratePerMonth: '월 요금',
  recentSearches: '최근 검색',
  region: '지역',
  register: '등록',
  resetPassword: '비밀번호 재설정',
  restricted: '제한됨',
  retro: '회고',
  review: '리뷰 및 평점',
  revisionSummary: '수정 요약',
  revisionURL: '수정 URL',
  resume: '이력서',
  resumeLink: '이력서 보기',
  rowsPerPage: '페이지당 행 수',
  save: '저장',
  search: '검색',
  searchProjects: '프로젝트 검색',
  secondarySkill: '보조 기술',
  select: '선택',
  selectArtName: 'ART 이름 선택',
  selectAUser: '사용자 선택',
  selectFilter: '필터 선택',
  applyFilters: '필터 적용',
  selectItemsPerPage: '페이지당 항목 선택',
  selectJiraIssues: 'Jira 이슈 선택',
  selectPod: 'POD 선택',
  selectPodTeamMember: 'POD 팀 멤버 선택',
  selectPods: 'POD 선택',
  services: '서비스',
  setting: '설정',
  shareableLink: '공유 가능한 링크',
  signUpToGetStarted: '시작하려면 아래에서 "가입"하세요!',
  getStarted: '시작하기',
  skills: '기술',
  skillsAndExpertise: '기술 및 전문성',
  sonarqubeprojectkey: 'Sonarqube 프로젝트 키',
  sonarqubeStats: 'Sonarqube 통계',
  specialization: '전문화',
  sprintVelocity: '스프린트 속도',
  sprint: '스프린트',
  spotsLeft: '남은 자리',
  startDate: '시작 날짜',
  startDoing: '시작하기',
  status: '상태',
  stopDoing: '중단하기',
  storyDescription: '스토리 설명',
  stories: '스토리',
  submit: '제출',
  submittedDate: '제출 날짜',
  submittedPRCount: '제출된 PR 수',
  subscription: '구독',
  talentApprovalRequests: '인재 승인 요청',
  talentCode: '인재 코드',
  taskForm: '작업 양식',
  taskManager: '작업 관리자',
  taskName: '작업 이름',
  tasks: '작업',
  teamMember: '팀 멤버',
  techStack: '기술 스택',
  termsOfService: '서비스 약관',
  testCases: '테스트 케이스',
  time: '시간',
  timeLog: '시간 로그',
  timeSubmit: '시간 제출',
  timeZone: '시간대',
  toDo: '할 일',
  todaysFocus: '오늘의 집중',
  totalLinesChangedLastWeek: '지난 주 총 변경 라인',
  totalLinesChangedThisWeek: '이번 주 총 변경 라인',
  totalPRCount: '총 PR 수',
  university: '대학교',
  update: '업데이트',
  updateProfileHere: '여기서 프로필을 업데이트하세요',
  updatingVisibility: '가시성 업데이트 중...',
  upload: '업로드',
  userStory: '사용자 스토리',
  validFrom: '유효 시작일',
  validTill: '유효 종료일',
  talentexplorer: '인재 탐색기',
  interviewrequests: '면접 요청',
  videoUrl: '비디오 URL',
  view: '보기',
  viewActivities: '활동 보기',
  viewDetails: '세부사항 보기',
  viewPodActivities: 'POD 활동 보기',
  viewPodDetails: 'POD 세부사항 보기',
  viewProfile: '프로필 보기',
  viewTasks: '작업 보기',
  viewTimeEntries: '시간 항목 보기',
  viewVideo: '비디오 보기',
  visitFindTalent: '"인재 찾기" 페이지를 방문하여 재능 있는 개인을 POD에 추가하세요.',
  vulnerabilities: '취약점',
  welcome: 'Artemy.ai에 오신 것을 환영합니다!',
  workExperience: '업무 경험',
  yourPod: '귀하의 POD',
  yourPods: '귀하의 POD',
  yourPostedPodActivity: '게시된 POD 활동',
  
  findTickets: '티켓 찾기',
  epics: '에픽',
  date: '날짜',
  talent: '인재',
  focus: '집중',
  startDate: '시작 날짜',
  endDate: '종료 날짜',
  status: '상태',
  allStatus: '모든 상태',
  blocked: '차단됨',
  onTrack: '정상 진행',
  activityDetails: '활동 세부사항',
  jiraIssues: 'Jira 이슈',
  todaysFocus: '오늘의 집중',
  accomplishments: '성과',
  blockers: '차단 요소',
  videoUpdate: '비디오 업데이트',
  comments: '댓글',
  addBlockerInformation: '차단 정보 추가',
  blockerDetails: '차단 세부사항',
  cancel: '취소',
  saveChanges: '변경사항 저장',
  selectJiraIssues: 'Jira 이슈 선택',
  design: '디자인',
  development: '개발',
  testing: '테스트',
  bugFix: '버그 수정',
  documentation: '문서화',
  myPods: '내 POD',
  postRetro: '회고 게시',
  newRetro: '새 회고',
  startDoing: '시작하기',
  stopDoing: '중단하기',
  keepDoing: '계속하기',
  viewRetros: '회고 보기',
  podRetroFeedback: 'POD 회고 피드백',
  selectSprint: '스프린트 선택',
  thisTaskIsBlocker: '이 작업은 차단 요소입니다',
  category: '카테고리',
  taskCreatedSuccessfully: '작업이 성공적으로 생성되었습니다!',
  taskManagement: '작업 관리',
  searchJiraIssues: 'JIRA 이슈 검색...',
  creatingTask: '작업 생성 중...',
  createTask: '작업 생성',
  description: '설명',
  dueDate: '마감일',
  commentsHistory: '댓글 기록',
  noCommentsYet: '아직 댓글이 없습니다',
  writeAComment: '댓글 작성...',
  all: '모두',
  blockerStatus: '차단 상태',
  blockedTasks: '차단된 작업',
  unblockedTasks: '차단되지 않은 작업',
  clearDateRange: '날짜 범위 지우기',
  selectDateRange: '날짜 범위 선택',
  showAllTime: '모든 시간 표시',
  noTasksFound: '작업을 찾을 수 없습니다',
  noLinkedIssues: '연결된 이슈 없음',
  timeSheet: '근무 시간표',
  podTimeSheet: 'POD 근무 시간표',
  userStory: '사용자 스토리',
  hours: '시간',
  minutes: '분',
  actions: '작업',
  submitTimeEntries: '시간 항목 제출',
  selectCategory: '카테고리 선택',
  selectStory: '스토리 선택',
  addRow: '행 추가',
  podSelection: 'POD 선택',
  selectPodToView: '스프린트 및 인재 필터를 보려면 POD를 선택하세요',
  toDo: '할 일',
  podAssist: 'POD 어시스턴트',
  inProgress: '진행 중',
  done: '완료',
  selectPodsRequired: 'POD 선택 (필수)',
  enterStoryDescription: '스토리 설명 입력',
  podSyncSummaries: 'POD 동기화 요약',
  enterMeetingUrl: '회의 URL 입력...',
  searchInSummaries: '요약에서 검색...',
  dateAndTime: '날짜 및 시간',
  quickTimeRange: '빠른 시간 범위',
  sortByDate: '날짜별 정렬',
  selectTalents: '인재 선택',
  filterBySpecificCandidates: '특정 후보자로 필터링 (선택사항)',
  talentSelection: '인재 선택',
  priority: '우선순위',
  addComment: '댓글 추가',
  taskDetails: '작업 세부사항',
  summary: '요약',
  addMeeting: '회의 추가',

  podAutomation: 'POD 자동화',
  uploading: '업로드 중...',
  uploadFile: '파일 업로드',
  send: '전송',
  submitting: '제출 중...',
  enterYourQuestionHere: '여기에 질문을 입력하세요',
  submitTheResults: '결과 제출',
  export: '내보내기',
  podInsights: 'POD 인사이트',
  askQuestionsAboutYourPod: 'POD 활동, 팀 멤버 등에 대해 질문하세요',
  welcomeToPodInsights: 'POD 인사이트에 오신 것을 환영합니다!',
  startByAskingQuestionsLike: '다음과 같은 질문으로 시작하세요',
  showAllPodActivitiesThatHadBlockers: '차단 요소가 있던 모든 POD 활동 표시',
  listAllCandidatesAndTheirPods: '모든 후보자와 그들의 POD 목록',
  showStakeholdersFromIndia: '인도의 이해관계자 표시',
  askAnythingAboutYourPods: 'POD, 팀 멤버, 활동에 대해 무엇이든 질문하세요...',
  sending: '전송 중...',
  analyzingYourQuestion: '질문 분석 중...',
  pipelineCICD: '파이프라인 CI/CD',
  tickets: '티켓',
  metricName: '메트릭 이름',
  metricValue: '메트릭 값',
  commentsHistory: '댓글 기록',
  noCommentsYet: '아직 댓글이 없습니다',
  writeAComment: '댓글 작성...',
  solutionManagement: '솔루션 관리',
  searchSolutions: '솔루션 검색...',
  refresh: '새로고침',
  createNewSolution: '새 솔루션 생성',
  solutionName: '솔루션 이름',
  solutionDescription: '솔루션 설명',
  updateSolution: '솔루션 업데이트',
  createSolution: '솔루션 생성',
  confirmSolutionDeletion: '솔루션을 삭제하시겠습니까',
  artManagement: 'ART 관리',
  podManagement: 'POD 관리',
  searchPods: 'POD 검색...',
  viewPod: 'POD 보기',
  searchARTs: 'ART 검색...',
  noARTsFound: 'ART를 찾을 수 없습니다. "새 ART 생성" 버튼을 클릭하여 첫 번째 ART를 생성하세요.',
  createNewART: '새 ART 생성',
  selectGig: '기그 선택',
  artName: 'ART 이름',
  artDescription: 'ART 설명',
  createART: 'ART 생성',
  confirmDeletion: '삭제 확인',
  confirmARTDeletion: 'ART를 삭제하시겠습니까',
  primaryLanguage: '주요 언어',
  selectSkills: '기술 선택',
  timeZone: '시간대',
  updateART: 'ART 업데이트',
  somethingWentWrong: '문제가 발생했습니다',
  reloadPage: '페이지 새로고침',
  privatePods: '비공개 POD',
  activePods: '활성 POD',
  completedPods: '완료된 POD',
  pendingPods: '대기 중인 POD',
  loadingPods: 'POD 로딩 중...',
  retry: '다시 시도',
  noPodsFound: 'POD를 찾을 수 없습니다',
  createFirstPod: '시작하려면 첫 번째 POD를 생성하세요',
  previous: '이전',
  showing: '표시 중',
  size: '크기',
  teamSize: '팀 크기',
  activeMembers: '활성 멤버',
  stakeholders: '이해관계자',
  podManagers: 'POD 관리자',
  addManager: '관리자 추가',
  podManager: 'POD 관리자',
  noManagersAssignedYet: '아직 할당된 관리자가 없습니다',
  addManagersToHelpOversee: '이 POD를 감독하는 데 도움이 되는 관리자를 추가하세요',
  noStakeholdersYet: '아직 이해관계자가 없습니다',
  settings: '설정',
  deletePod: 'POD 삭제',
  addPodManager: 'POD 관리자 추가',
  selectManagerToInvite: '이 POD에 초대할 관리자를 선택하세요:',
  noManagersAvailableToInvite: '초대할 수 있는 관리자가 없습니다.',
  selectAManager: '관리자 선택',
  selectedManager: '선택된 관리자',
  inviteManager: '관리자 초대',
  noTeamMembersYet: '아직 팀 멤버가 없습니다',
  startByInvitingMembers: 'POD에 멤버를 초대하는 것부터 시작하세요',
  inviteTeamMembers: '팀 멤버 초대',
  existingMembers: '기존 멤버',
  inviteByEmail: '이메일로 초대',
  searchByNameOrSkills: '이름 또는 기술로 검색...',
  optionalSelectUserToNotify: '선택사항: Slack을 통해 알림을 받을 사용자 선택',
  pleaseSelectPodToEnableFields: '다른 필드를 활성화하려면 POD를 선택하세요',
  selectedCandidates: '선택된 후보자',
  selectCandidatesToInvite: '이 POD에 초대할 후보자를 선택하세요',
  availableCandidates: '사용 가능한 후보자',
  inviteNewMembersByEmail: '이메일로 새 멤버 초대',
  emailAddresses: '이메일 주소',
  enterEmailAddresses: '이메일 주소 입력 (쉼표로 구분)',
  hidePodTeamMembers: 'POD 찾기 섹션에서 이 POD 팀 멤버 숨기기 (현재 표시됨)',
  technicalDetails: '기술 세부사항',
  currentTeamSize: '현재 팀 크기',
  communicationDetails: '커뮤니케이션 세부사항',
  podReview: 'POD 리뷰',
  rating: '평점',
  writeReview: '리뷰 작성',
  shareYourExperience: '이 POD에 대한 경험을 공유하세요...',
  submitReview: '리뷰 제출',
  viewPod: 'POD 보기',
  managePod: 'POD 관리',
  editPod: 'POD 편집',
  skillsAndExperience: '기술 및 경험',
  reviews: '리뷰',
  documents: '문서',
  otherInfo: '기타 정보',
  noWorkExperienceDataAvailable: '사용 가능한 업무 경험 데이터가 없습니다',
  selectART: 'ART 선택',
  selectAnART: 'ART 선택',
  jiraConfiguration: 'Jira 설정',
  jiraProjectKey: 'Jira 프로젝트 키',
  jiraURL: 'Jira URL',
  jiraAdminEmail: 'Jira 관리자 이메일',
  jiraAdminAPIToken: 'Jira 관리자 API 토큰',
  jiraOpenStoryBugStatus: 'Jira 열린 스토리/버그 상태',
  jiraClosedStoryBugStatus: 'Jira 닫힌 스토리/버그 상태',
  gitHubConfiguration: 'GitHub 설정',
  gitHubUsername: 'GitHub 사용자명',
  gitHubAPIToken: 'GitHub API 토큰',
  gitHubRepositoryName: 'GitHub 저장소 이름',
  circleCIConfiguration: 'CircleCI 설정',
  circleCIGitHubUsername: 'CircleCI GitHub 사용자명',
  circleCIGitHubRepository: 'CircleCI GitHub 저장소',
  circleCIAPIToken: 'CircleCI API 토큰',
  sonarQubeConfiguration: 'SonarQube 설정',
  sonarQubeCloudURL: 'SonarQube 클라우드 URL',
  sonarQubeAPIToken: 'SonarQube API 토큰',
  awsConfiguration: 'AWS 설정',
  awsAccessKeyID: 'AWS 액세스 키 ID',
  awsSecretAccessKey: 'AWS 비밀 액세스 키',
  awsRegion: 'AWS 리전',
  bitBucketConfiguration: 'BitBucket 설정',
  bitBucketUsername: 'BitBucket 사용자명',
  bitBucketAppPassword: 'BitBucket 앱 비밀번호',
  bitBucketWorkspace: 'BitBucket 워크스페이스',
  openAIConfiguration: 'OpenAI 설정',
  openAIToken: 'OpenAI 토큰',
  storyPointsCalculation: '스토리 포인트 계산',
  uploadStoryPointsCalculationFile: '스토리 포인트 계산 파일 업로드',
  currentFile: '현재 파일',
  notifications: '알림',
  markAllAsRead: '모두 읽음으로 표시',
  tryAgain: '다시 시도',
  noNotificationsToDisplay: '표시할 알림이 없습니다',
  viewAllNotifications: '모든 알림 보기',
  enterMultipleEmailsSeparatedByCommas: '쉼표로 구분된 여러 이메일 입력',
  addEmailAddressesToInvite: '새 멤버를 초대하기 위한 이메일 주소 추가',
  emailInvitationGuidelines: '이메일 초대 가이드라인',
  inviteesWillReceiveInstructions: '초대받은 사람들은 이 POD에 참여하기 위한 지침을 받게 됩니다',
  theyWillNeedToCreateAccount: '아직 계정이 없다면 계정을 생성해야 합니다',
  noCandidatesAvailable: '사용 가능한 후보자가 없습니다',
  sendEmailInvites: '이메일 초대 보내기',

  processingDataAndGeneratingInsights: '데이터 처리 및 인사이트 생성 중',
  retroHistory: '회고 기록',
  filterByMember: '멤버별 필터',
  podProductivity: 'POD 생산성',
  totalTasks: '총 작업 수',
  completed: '완료됨',
  clearFilters: '필터 지우기',
  totalActivities: '총 활동 수',
  pendingApproval: '승인 대기 중',
  sortBy: '정렬 기준',
  editSolution: '솔루션 편집',
  cannotDeleteAssociatedWithARTs: '삭제할 수 없음 - ART와 연관됨',
  editART: 'ART 편집',
  createdDate: '생성 날짜',
  podDetails: 'POD 세부사항',
  currentARTProject: '현재 ART/프로젝트',
  artProject: 'ART/프로젝트',
  selectAvailability: '가용성 선택',
  selectSkill: '기술 선택',
  selectTimezone: '시간대 선택',
  selectLocation: '위치 선택',
  selectBudget: '예산 선택',
  podMember: 'POD 멤버',
  addToPod: 'POD에 추가',
  talentDetails: '인재 세부사항',
  reviewsFeedback: '리뷰 및 피드백',
  noEducationDataAvailable: '사용 가능한 교육 데이터가 없습니다',
  noCertificationDataAvailable: '사용 가능한 인증 데이터가 없습니다',
  clientReview: '클라이언트 리뷰',
  noReviewsAvailableYet: '아직 사용 가능한 리뷰가 없습니다',
  noClientReviews: '이 인재는 아직 클라이언트 리뷰를 받지 못했습니다',
  resumeAvailable: '이력서 사용 가능',
  viewDownloadResume: '후보자의 이력서를 보거나 다운로드',
  noResumeAvailable: '사용 가능한 이력서가 없습니다',
  noResumeUploaded: '이 인재는 이력서를 업로드하지 않았습니다.',
  codingAssessment: '코딩 평가',
  assessmentAvailable: '평가 사용 가능',
  viewAssessmentResults: '후보자의 코딩 평가 결과 보기',
  noAssessmentAvailable: '사용 가능한 평가가 없습니다',
  noAssessmentCompleted: '이 인재는 코딩 평가를 완료하지 않았습니다.',
  partnerCompanyDetails: '파트너 회사 세부사항',
  companyIntroductionVideo: '회사 소개 비디오',
  videoNotSupported: '브라우저가 비디오 태그를 지원하지 않습니다.',
  location: '위치',
  noPodsMatchingCriteria: '귀하의 기준에 맞는 POD를 찾을 수 없습니다',
  hirePod: 'POD 고용',
  notificationHistory: '알림 기록',
  filter: '필터',
  allNotifications: '모든 알림',
  markSelected: '선택한 것 표시',
  unread: '읽지 않음',
  noNotificationsFound: '알림을 찾을 수 없습니다',
  searchNotifications: '알림 검색...',
  subscriptionManagement: '구독 관리',
  choosePlanPrompt: '귀하의 요구에 가장 적합한 플랜을 선택하고 성장에 따라 확장하세요',
  cancelSubscription: '구독 취소',
  choosePlan: '플랜 선택',
  noPlansAvailable: '사용 가능한 플랜 없음',
  noPlansHelpText: '나중에 다시 확인하거나 지원팀에 문의하여 도움을 받으세요.',
  currentPlanDetails: '현재 플랜 세부정보',
  renewalDate: '갱신 날짜',
  subscriptionId: '구독 ID',
  paymentMethod: '결제 방법',
  cardHolder: '카드 소유자',
  expires: '만료',
  brand: '브랜드',
  billingHistory: '청구 내역',
  noInvoiceHistory: '사용 가능한 송장 내역이 없습니다',
  needHelp: '도움이 필요하신가요?',
  supportText: '구독 플랜에 대한 질문이 있거나 도움이 필요하시면 저희 지원팀이 도와드리겠습니다.',
  contactSupport: '지원팀 연락',
  completeSubscription: '구독 완료',
  planDetails: '플랜 세부정보',
  planName: '플랜 이름',
  basePrice: '기본 가격',
  numberOfUsers: '사용자 수',
  billingCycle: '청구 주기',
  orderSummary: '주문 요약',
  annualDiscount: '연간 할인',
  billingPeriod: '청구 기간',
  tax: '세금',
  totalWithTax: '세금 포함 총액',
  annually: '연간',
  continue: '계속',
  subscriptionSuccessful: '구독 성공!',
  thankYouSubscribing: '구독해 주셔서 감사합니다',
  subscriptionActivated: '구독이 성공적으로 활성화되었습니다.',
  goToDashboard: '대시보드로 이동',
  addPaymentMethod: '결제 방법 추가',
  cardNumber: '카드 번호',
  cardholderName: '카드 소유자 이름',
  expiryMonth: '만료 월',
  expiryYear: '만료 년',
  postalCode: '우편번호',
  addCard: '카드 추가',
  paymentChoice: '기존 카드 사용 또는 새 카드 추가',
  existingCardText: '이미 다음으로 끝나는 기존 카드가 있습니다',
  useExistingCardPrompt: '이 구독에 사용하시겠습니까?',
  useExistingCard: '기존 카드 사용',
  addNewCard: '새 카드 추가',
  processing: '처리 중...',
  subscriptionSuccessDetails: '성공했습니다!',
  accessAllFeatures: '이제 구독 플랜에 포함된 모든 기능에 액세스할 수 있습니다.',
  editCardDetails: '카드 세부정보 편집',
  managerInvite: '매니저 초대',
  talentInvite: '인재 초대',
  invitePodManagers: '포드 매니저를 초대하려면 이메일을 입력하세요',
  enterEmail: '이메일 입력',
  invite: '초대',
  yourInvoices: '귀하의 송장',
  noInvoices: '송장이 없습니다.',
  amountDue: '미납 금액',
  amountPaid: '지불된 금액',
  getCountIsseswithNoCritria: '수락 기준이 없는 이슈 수 가져오기',
  noActiveSubscription: '활성 구독 플랜이 없습니다. 구독을 추가하려면 "구독" 링크를 클릭하세요.',
   noActiveSubscriptionStart: '활성 구독 플랜이 없습니다.',
  subscribe: '구독',
  noActiveSubscriptionEnd: '링크를 클릭하여 구독을 추가하세요.'
};

export default messagesKo;